<template>
	<div class="couponReceive_item" @click.stop="couponTap">
        <img :src="returnBgImage()" alt=""></img>
        <img :src="$img(couponImageStateObj[state])" alt=""></img>
        <div :class="state==='1'?couponTextClor_obj[info.type]:couponTextClor_obj['expired']">
            <div>
                <div :class="state==='1'?couponBorderClor_obj[info.type]:couponBorderClor_obj['expired']">
                    <span>{{ info.goods_type == 1 ? '全场商品' : '指定商品' }}</span>
                    <template v-if="info.type === 'reward' || info.type === 'ladder_reward' || info.type === 'no_threshold'">
                        <div class="reward">
                            <span>￥</span>
                            <span>{{ info.money }}</span>
                        </div>
                    </template>
                    <template v-if="info.type === 'discount'">
                        <div class="discount">
                            <span>{{ info.discount }}</span>
                            <span>折</span>
                        </div>
                    </template>
                </div>
                <div>
                    <span>{{ couponText_obj[info.type] }}</span>
                    <!-- 横线隔开 -->
                    <div :class="state==='1'?couponBorderClor_obj_solid[info.type]:couponBorderClor_obj_solid['expired']"></div>
                    <template v-if="info.at_least!=='0.00'">
                        <span>满{{ info.at_least }}可用</span>
                    </template>
                    <template v-else>
                        <span>无门槛优惠</span>
                    </template>
                </div>
            </div>
            <div>
                <span v-if="info.validity_type">领取之日起{{ info.fixed_term }}日内有效</span>
                <span v-else>有效期：{{ $timeStampTurnTime(info.end_time) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'couponReceive',
		props: {
			info: {
				type: Object,
                required: true
			},
            state: {
                type: String,
                required: true
            }
		},
        data() {
            return {
                couponTextClor_obj: {
                    reward:'couponTextClor_reward',
                    discount:'couponTextClor_discount',
                    no_threshold:'couponTextClor_no_threshold',
                    ladder_reward:'couponTextClor_ladder_reward',
                    expired:'couponTextClor_expired'
                },
                couponBorderClor_obj: {
                    reward:'couponBorderClor_reward_dashed',
                    discount:'couponBorderClor_discount_dashed',
                    no_threshold:'couponBorderClor_no_threshold_dashed',
                    ladder_reward:'couponBorderClor_ladder_reward_dashed',
                    expired:'couponBorderClor_expired_dashed'
                },
                couponBorderClor_obj_solid: {
                    reward:'couponBorderClor_reward_solid',
                    discount:'couponBorderClor_discount_solid',
                    no_threshold:'couponBorderClor_no_threshold_solid',
                    ladder_reward:'couponBorderClor_ladder_reward_solid',
                    expired:'couponBorderClor_expired_solid'
                },
                couponBgClor_obj: {
                    reward:'couponBgClor_reward',
                    discount:'couponBgClor_discount',
                    no_threshold:'couponBgClor_no_threshold',
                    ladder_reward:'couponBgClor_ladder_reward',
                    expired:'couponBgClor_expired'  
                },
                couponText_obj: {
                    reward:'一次性满减券',
                    discount:'折扣券',
                    no_threshold:'无门槛券',
                    ladder_reward:'阶梯性满减券'
                },
                couponImageBgObj: {
                    reward:'/upload/uniapp/coupon/coupon_bg2.png', // 一次性满减 
                    discount:'/upload/uniapp/coupon/coupon_bg3.png',// 折扣券
                    no_threshold:'/upload/uniapp/coupon/coupon_bg4.png',// 无门槛
                    ladder_reward:'/upload/uniapp/coupon/coupon_bg1.png',// 阶梯性满减
                    expired:'/upload/uniapp/coupon/coupon_bg5.png'// 已过期背景
                },
                couponImageStateObj: {
                    // 未使用 已使用 已过期
                    1:'/upload/uniapp/coupon/coupon_state1.png',
                    2:'/upload/uniapp/coupon/coupon_state2.png',
                    3:'/upload/uniapp/coupon/coupon_state3.png'
                }
            }
        },
		methods: {
            couponTap(){
                this.$emit('useCoupon',this.info);
            },
            returnBgImage(){
                return this.state==='1'?this.$img(this.couponImageBgObj[this.info.type]):this.$img(this.couponImageBgObj['expired']);
            }
		}
	};
</script>
<style lang="scss" scoped>
.couponReceive_item{
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    >img{
        position: absolute;
    }
    >img:nth-child(1){
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }
    >img:nth-child(2){
        left: -11px;
        top: -9px;
        width: 50px;
        z-index: 2;
    }
    // 声明颜色变量
    $couponClor_reward:#FB2B5A;
    $couponClor_discount:#D86262;
    $couponClor_no_threshold:#C50808;
    $couponClor_ladder_reward:#F7640A;
    $couponClor_expired:#3D3D3D;
    .couponTextClor_reward{
        color: $couponClor_reward;
    }
    .couponTextClor_discount{
        color: $couponClor_discount;
    }
    .couponTextClor_no_threshold{
        color: $couponClor_no_threshold;
    }
    .couponTextClor_ladder_reward{
        color: $couponClor_ladder_reward;
    }
    .couponTextClor_expired{
        color: $couponClor_expired;
    }
    .couponBorderClor_reward_dashed{
        border-right: 1px dashed $couponClor_reward;
    }
    .couponBorderClor_discount_dashed{
        border-right: 1px dashed $couponClor_discount;
    }
    .couponBorderClor_no_threshold_dashed{
        border-right: 1px dashed $couponClor_no_threshold;
    }
    .couponBorderClor_ladder_reward_dashed{
        border-right: 1px dashed $couponClor_ladder_reward;
    }
    .couponBorderClor_expired_dashed{
        border-right: 1px dashed $couponClor_expired;
    }
    .couponBorderClor_reward_solid{
        border-bottom: 1px solid $couponClor_reward;
    }
    .couponBorderClor_discount_solid{
        border-bottom: 1px solid $couponClor_discount;
    }
    .couponBorderClor_no_threshold_solid{
        border-bottom: 1px solid $couponClor_no_threshold;
    }
    .couponBorderClor_ladder_reward_solid{
        border-bottom: 1px solid $couponClor_ladder_reward;
    }
    .couponBorderClor_expired_solid{
        border-bottom: 1px solid $couponClor_expired;
    }
    .couponBgClor_reward{
        background-color: $couponClor_reward;
    }
    .couponBgClor_discount{
        background-color: $couponClor_discount;
    }
    .couponBgClor_no_threshold{
        background-color: $couponClor_no_threshold;
    }
    .couponBgClor_ladder_reward{
        background-color: $couponClor_ladder_reward;
    }
    .couponBgClor_expired{
        background-color: $couponClor_expired;
    }
    >div{
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 3;
        width: 100%;
        >div:nth-child(1){
            display: flex;
            align-items: center;
            width: 100%;
            margin-bottom: 10px;
            >div{
                display: flex;
                flex-direction: column;
            }
            >div:nth-child(1){
                display: flex;
                align-items: center;
                width: 50%;
                .reward{
                    display: flex;
                    align-items: flex-start;
                    >span:nth-child(1){
                        font-weight: 700;
                        font-size: 18px;
                        line-height: 25px;
                    }
                    >span:nth-child(2){
                        font-weight: bold;
                        font-size: 24px;
                        line-height: 32px;
                    }
                }
                .discount{
                    display: flex;
                    align-items: flex-start;
                    >span{
                        font-weight: bold;
                        font-size: 24px;
                        line-height: 32px;
                    }
                }
            }
            >div:nth-child(2){
                width: 50%;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                padding: 0 20px;
                box-sizing: border-box;
                >div{
                    width: 100%;
                }
                >span:nth-child(1){
                    font-weight: bold;
                }
            }
        }
        >div:nth-child(2){
            position: absolute;
            bottom: 6px;
        }
    }
}
</style>
